import AnimeList from "../views/animationManage/animeList";
import LatitudeList from "../views/animationManage/latitudeList";
import AnimeTagsList from "../views/animationManage/animeTagsList";
// import AnimeContentList from "../views/animationManage/animeContentList";
import CartoonBatchUpdList from "../views/animationManage/bulkUpload";
import SubsetBatchUpdList from "../views/animationManage/subsetBatchUpdList";
import AcgVidResCfg from "../views/animationManage/acgVidResCfg";
import RecommendList from "../views/animationManage/recommendList";
import TaskList from "../views/animationManage/taskList";
import Main from "../views/main";

const animeRouter = {
  path: "/animeList",
  component: Main,
  title: "动漫管理",
  icon: "el-icon-video-camera-solid",
  meta: { keepAlive: true },
  children: [
    {
      path: "/animeList",
      component: AnimeList,
      name: "animeList",
      title: "动漫列表",
      meta: { title: "动漫列表", keepAlive: true },
    },
    {
      path: "/recommendList",
      component: RecommendList,
      name: "recommendList",
      title: "推荐列表",
      meta: { title: "推荐列表", keepAlive: true },
    },
    {
      path: "/taskList",
      component: TaskList,
      name: "taskList",
      title: "任务列表",
      meta: { title: "任务列表", keepAlive: true },
    },
    {
      path: "/cartoon-batchUpd-list",
      component: CartoonBatchUpdList,
      name: "cartoonBatchUpdList",
      title: "批量上传",
      meta: {
        title: "批量上传",
        keepAlive: true,
      },
    },
    {
      path: "/subset-batchUpd-list",
      component: SubsetBatchUpdList,
      name: "subsetBatchUpdList",
      title: "子媒体批量上传",
      meta: {
        title: "子媒体批量上传",
        keepAlive: true,
      },
    },
    // {
    //   path: "/animeContentList",
    //   component: AnimeContentList,
    //   name: "animeContentList",
    //   title: "动漫内容列表",
    //   meta: { title: "动漫内容列表", keepAlive: true },
    // },
    {
      path: "/animeTagsList",
      component: AnimeTagsList,
      name: "animeTagsList",
      title: "标签列表",
      meta: { title: "标签列表", keepAlive: true },
    },
    {
      path: "/latitudeList",
      component: LatitudeList,
      name: "latitudeList",
      title: "维度列表",
      meta: { title: "维度列表", keepAlive: true },
    },
    {
      path: "/acg-vid-res-cfg",
      component: AcgVidResCfg,
      name: "acgVidResCfg",
      title: "Acg媒体资源库",
      meta: { title: "Acg媒体资源库", keepAlive: true },
    },
  ],
};

export default animeRouter;
